/**
 * The default configuration to use.
 * @type {ExecutionContextConfig}
 */
exports.DEFAULT_CONFIG = {
    monitor: false
};
